import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import label from "../labels/common_en.json";
import { uploadMastersData, getAllMasterTypes } from "../actions/commonActions";
function MastersCsvImport() {
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });

  const [selectedUploadFile, setSelectedUploadFile] = useState("");
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [reloadItem, setReloadItem] = useState(true);
  const [selectedType, setSelectedType] = useState("");
  const [allTypes, setAllTypes] = useState([]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllMasterTypes());
  }, []);

  let { masterTypesList } = useSelector((state) => state.common, shallowEqual);
  useEffect(() => {
    setAllTypes(masterTypesList);
  }, [masterTypesList]);
  useEffect(() => {}, [reloadItem]);

  const onTypeChange = (ele) => {
    let selType = ele;
    setSelectedType(selType);
    setReloadItem(!reloadItem);
  };

  const onSubmit = () => {
    let data = {};
    data.file = selectedUploadFile;
    data.type = "importData";
    dispatch(uploadMastersData(selectedType, data, setSelectedType));
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };

  const onCancelButton = () => {
    setSelectedType("");
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };

  const onUploadFileChange = (e) => {
    if (e.target.files.length === 0) {
      return;
    }
    setSaveButtonFlag(false);
    let selectedValue = e.target.files[0];
    setSelectedUploadFile(selectedValue);
    setReloadItem(!reloadItem);
  };

  return (
    <div className="dashboardContentArea">
      <h5> {label.MastersCsvImport} </h5>
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-3">
                  <label className="float-left">
                    {label.SelectType}s
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedType"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onTypeChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {label.COMBO_SELECT}
                    </option>
                    {allTypes &&
                      allTypes.length > 0 &&
                      allTypes.map((element, index) => (
                        <option key={index} value={element.type}>
                          {element.name}
                        </option>
                      ))}
                  </select>
                  {_.get("selectedType.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {label.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-3">
                  <label className="float-left">
                    {label.SelectUploadFile}
                    <span className="errorText">*</span>
                  </label>
                  <input
                   className="form-control"
                    type="file"
                    accept=".xlsx, .xls, .csv"
                    name="selectedUploadFile"
                    onChange={(e) => {
                      onUploadFileChange(e);
                    }}
                  />
                  {_.get("selectedUploadFile.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {label.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-6 mt-3">
                  <button
                    type="reset"
                    className="btn btn-secondary mr-2"
                    onClick={() => onCancelButton()}
                  >
                    {label.BUTTON_CANCEL}
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={saveButtonFlag}
                    onClick={handleSubmit((e) => {
                      onSubmit(e);
                    })}
                  >
                    {label.BUTTON_SAVE}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default MastersCsvImport;
